import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import sparkles from './assets/stars.svg';
import { languages, languageCodes, languageQuestions } from './constants';

const SearchBox = () => {
    const [query, setQuery] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState("English");
    const urlParams = new URLSearchParams(window.location.search);
    const websiteRef = urlParams.get("websiteRef");
    const parentDivRef = useRef(null);

    // Listen for language updates from parent
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data.type === 'languageChange') {
                setSelectedLanguage(event.data.language);
            }
        };
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    const handleSearch = () => {
        if (!query.trim()) return;
        
        const searchParams = {
            query,
            websiteRef,
            selected_language: selectedLanguage
        };
    
        window.parent.postMessage({
            type: 'searchParameters',
            data: searchParams
        }, '*');
    };

    useEffect(() => {
        const sendHeightToParent = () => {
            if (parentDivRef.current) {
                const height = parentDivRef.current.getBoundingClientRect().height;
                window.parent.postMessage({
                    type: 'searchBoxHeight',
                    height: height
                }, '*');
            }
        };
    
        const observer = new ResizeObserver(sendHeightToParent);
    
        if (parentDivRef.current) {
            observer.observe(parentDivRef.current);
            sendHeightToParent();
        }
    
        const sendInitialConstants = () => {
            window.parent.postMessage({
                type: 'initialConstants',
                constants: {
                    languages: languages,
                    languageCodes: languageCodes,
                    languageQuestions: languageQuestions
                }
            }, '*');
        };
    
        sendInitialConstants();
    
        return () => {
            observer.disconnect();
        };
    }, []);
    
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    return (
        <div className="relative w-full" ref={parentDivRef}>
            <div className="relative p-[2px] rounded-lg">
                <div className="absolute inset-0 rounded-lg overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-[#4900ff] via-[#a166ab] to-[#000000] animate-gradient"></div>
                </div>
                <div className="relative flex items-center bg-white rounded-lg shadow-sm">
                    <img className="absolute left-3 h-4 w-4 z-10" src={sparkles} alt="sparkles" />
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder={languageQuestions[selectedLanguage]}
                        className="w-full pl-10 pr-[60px] py-3 rounded-l-lg focus:outline-none"
                    />
                    <button
                        onClick={handleSearch}
                        className="flex items-center justify-center px-4 py-3 text-white bg-[#4900ff] hover:bg-blue-600 transition-colors border border-gray-300 rounded-r-lg mr-1 my-1"
                    >
                        <Search size={20} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchBox;